import { createReduxConstants } from '@bibliocommons/utils-redux';

export default createReduxConstants('APP', {
  INITIALIZE: null
});
